import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import logoAimHigh from '../assets/aim-high-childrens-services-logo.jpg';
import logoCollapsed from '../assets/logo_collapsed.svg';
import logoEnhancedServices from '../assets/logo-enhanced-services.svg';
import { BrandType, useBrandConfig } from '../config/BrandConfig';

type LogoProps = {
  className?: string;
  isCollapsed?: boolean;
};

const getLogo = (brand: BrandType, isCollapsed: boolean) => {
  if (isCollapsed) {
    return logoCollapsed;
  }

  return brand === 'aim-high' ? logoAimHigh : logoEnhancedServices;
};

const getAltText = (brand: BrandType) => {
  return brand === 'aim-high' ? "Aim High Children's Services logo" : 'Enhanced services logo';
};

const Logo = ({ className, isCollapsed = false }: LogoProps) => {
  const { brand } = useBrandConfig();
  const logo = getLogo(brand, isCollapsed);
  const altText = getAltText(brand);

  const shouldEnlarge = brand === 'aim-high' && !isCollapsed;

  return (
    <img src={logo} alt={altText} className={twMerge(clsx(shouldEnlarge && 'h-8'), className)} />
  );
};

export default Logo;
